function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M664.397 25.749L56.3135 183.01L80.1822 275.304L688.266 118.042L664.397 25.749Z",
  fill: "url(#pencil_gradient1)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M683.832 100.897L41.1465 267.106L55.338 321.981L698.023 155.771L683.832 100.897Z",
  fill: "url(#pencil_gradient2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M683.822 100.899L38.1743 267.875L41.7547 281.72L687.403 114.744L683.822 100.899Z",
  fill: "#7490C3",
  fillOpacity: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M694.433 141.929L48.7856 308.905L52.3661 322.75L698.014 155.774L694.433 141.929Z",
  fill: "url(#pencil_gradient3)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M785.438 107.486L760.321 121.357L698.024 155.771L683.832 100.897L755.001 100.784L783.693 100.738C784.491 100.739 785.266 101.004 785.896 101.492C786.527 101.981 786.977 102.665 787.177 103.437C787.377 104.209 787.314 105.026 787 105.759C786.685 106.492 786.136 107.099 785.438 107.486Z",
  fill: "url(#pencil_gradient4)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M785.438 107.486L760.321 121.357L755 100.784L783.693 100.738C784.491 100.739 785.266 101.004 785.896 101.492C786.527 101.981 786.977 102.665 787.177 103.437C787.377 104.209 787.314 105.026 787 105.759C786.685 106.492 786.136 107.099 785.438 107.486Z",
  fill: "url(#pencil_gradient5)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M112.654 248.613L41.1465 267.106L55.338 321.981L126.845 303.488L112.654 248.613Z",
  fill: "url(#pencil_gradient6)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7482 258.158L89.9398 313.032L48.9968 323.621C45.1726 324.61 41.1122 324.04 37.7081 322.036C34.304 320.033 31.8348 316.759 30.8433 312.936L24.1105 286.902C23.1211 283.076 23.692 279.014 25.6977 275.609C27.7033 272.204 30.9794 269.736 34.8053 268.746L75.7482 258.158Z",
  fill: "url(#pencil_gradient7)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M195.512 246.572L129.765 263.575L134.367 281.37L200.114 264.367L195.512 246.572Z",
  fill: "url(#pencil_gradient8)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient1",
  x1: 383.641,
  y1: 193.56,
  x2: 360.44,
  y2: 105.607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7490C3",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0416667,
  stopColor: "#7490C3",
  stopOpacity: 0.48
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#7490C3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient2",
  x1: 48.2423,
  y1: 294.544,
  x2: 690.928,
  y2: 128.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#233868"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#223A6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient3",
  x1: 50.5759,
  y1: 315.827,
  x2: 696.233,
  y2: 148.849,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#1A2C42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#23495E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#285C6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#2A6275"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#275274"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#234172"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient4",
  x1: 750.581,
  y1: 160.296,
  x2: 725.579,
  y2: 64.0608,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#2A6275"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#275071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#233F6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#22396C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#415A8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#5D77AA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#6E8ABD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#7490C3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient5",
  x1: 775.219,
  y1: 117.855,
  x2: 769.896,
  y2: 97.954,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#243258"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient6",
  x1: 89.0257,
  y1: 304.107,
  x2: 74.2289,
  y2: 248.769,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#243257"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#28375D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#34456D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#485C88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#647DAD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7490C3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient7",
  x1: 61.7719,
  y1: 317.662,
  x2: 48.3502,
  y2: 266.803,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#233868"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223A6F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pencil_gradient8",
  x1: 132.066,
  y1: 272.473,
  x2: 197.813,
  y2: 255.469,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#233868"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#223A6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223B72"
})));

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 795 328",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1809e996.svg";
export { ForwardRef as ReactComponent };